module.exports = __webpack_public_path__ + "public/images/logo_telegram.201a2f0624b850aadebaa82e53928137.svg";